const markdownitLinkAttributes = (md, config) => {
  /* eslint-disable no-param-reassign */

  const { navigateToFuncName } = config;
  const attr = 'onclick';
  const defaultRender = md.renderer.rules.link_open;

  md.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    const link = tokens[idx];
    const href = link.attrs[link.attrIndex('href')][1];

    if (/^\//.test(href)) {
      const value = `${navigateToFuncName}('${href}'); return false;`;
      const attrIndex = tokens[idx].attrIndex('onclick');

      if (attrIndex < 0) {
        tokens[idx].attrPush([attr, value]);
      } else {
        tokens[idx].attrs[attrIndex][1] = value;
      }
    }

    return defaultRender(tokens, idx, options, env, self);
  };
};

export default markdownitLinkAttributes;
